import { type VariantProps, cva } from "class-variance-authority";
import { type HTMLAttributes, forwardRef } from "react";
import { cn } from "../lib/cn";

export const headingVariants = cva("font-semibold tracking-tight", {
	variants: {
		size: {
			xs: "text-xs",
			sm: "text-sm",
			md: "text-base",
			lg: "text-lg",
			xl: "text-xl",
			"2xl": "text-2xl",
			"3xl": "text-3xl",
		},
	},
	defaultVariants: {
		size: "xl",
	},
});

type HeadingElement = "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
type HeadingSize = "xs" | "sm" | "md" | "lg" | "xl" | "2xl" | "3xl";

export interface HeadingProps
	extends HTMLAttributes<HTMLHeadingElement>,
		VariantProps<typeof headingVariants> {
	as?: HeadingElement;
	size?: HeadingSize;
}

const Heading = forwardRef<HTMLHeadingElement, HeadingProps>(
	({ className, as: Tag = "h2", size = "xl", ...props }, ref) => (
		<Tag
			ref={ref}
			className={cn(headingVariants({ size }), className)}
			{...props}
		/>
	),
);
Heading.displayName = "Heading";

export default Heading;
export { Heading };
